import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    user: {
    },
    lesson: {
      zkp: '',
      questions: [],
    },
    params: {
    },
    model: null,
    assignments: {},
    tokens: {},
    isAssignments: false,
    errorMsg: null,
    lessonStart: null,
    questionPrev: [],
    questionsPreload: [],
  },
  getters: {
    user(state) {
      return state.user
      // console.log('user',state.user)
    },
    model(state) {
      return state.model
    },
    assignments(state) {
      return state.assignments
    },
    isAssignments(state) {
      return state.isAssignments
    },
    lesson(state) {
      return state.lesson
    },
    tokens(state) {
      return state.tokens
    },
    errorMsg(state) {
      msg = state.errorMsg
      state.errorMsg = null
      return msg
    },
    params(state) {
      return state.params
    },
    lessonStart(state) {
      return state.lessonStart
    },
    questionsPreload(state) {
      return state.questionsPreload
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setUserData(state, key, data) {
      state.user.key = data
    },
    setModel(state, model) {
      state.model = model
    },
    setAssignments(state, assignments) {
      state.assignments = assignments
      state.isAssignments = Boolean(assignments.length)
    },
    setLesson(state, lesson) {
      state.lesson = lesson
    },
    setTokens(state, tokens) {
      state.tokens = tokens
    },
    setErrorMsg(state, msg) {
      state.errorMsg = msg
    },
    setParam(state, params) {
      state.params = params
    },
    setLessonStart(state, lessonStart) {
      state.lessonStart = lessonStart
    },
    setQuestionsPreload(state, qstPreload) {
      state.questionsPreload = qstPreload
    },
  }
})




// WEBPACK FOOTER //
// ./src/store/store.js